module.exports = __webpack_public_path__ + "img/광주 피자.df54be09.png";